




















import * as VueGoogleMaps from "vue2-google-maps"
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {nextTick} from "process"
import { setInterval, clearInterval } from "timers";
declare var google: any

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBQGMb_yvFmI2LebLhFne43U-2KgYXNHVE",
    libraries: "places,directions" // necessary for places input
  }
});

@Component({
    components : {
    },
})
export default class Map extends Vue{

    @Prop({}) destination: string;

    searchAddressInput:string = '';
    currentLocation:{
        lat:number,
        lng:number
    } = null;
    
    mounted(){
       this.geolocation();
       this.getRoute();
    };

    geolocation(){
        navigator.geolocation.getCurrentPosition((position) => {
            this.currentLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        });
    }

    searchLocation(){
    //   var geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({'address': this.searchAddressInput}, (results, status) => {
    //     if (status === 'OK') {
    //       this.currentLocation.lat = results[0].geometry.location.lat();
    //       this.currentLocation.lng = results[0].geometry.location.lng();
    //     }
    //   });
    }

    directionsService=null;
    directionsDisplay=null;

    getRoute(){
        nextTick(()=>{
            let interval = setInterval(() => {
                if(this.$refs.mapRef != undefined){
                    this.directionsService = new google.maps.DirectionsService()
                    this.directionsDisplay = new google.maps.DirectionsRenderer()
                    this.directionsDisplay.setMap((this.$refs.mapRef as any).$mapObject)
                    let origin = this.currentLocation? new google.maps.LatLng(this.currentLocation.lat, this.currentLocation.lng):"Blue Tongue Outdoor SA";
                    var vm = this;

                    vm.directionsService.route({
                        origin: origin,
                        destination: this.destination,
                        provideRouteAlternatives: false,
                        travelMode: 'DRIVING',
                        drivingOptions: {
                            departureTime: new Date(/* now, or future date */),
                            trafficModel: 'pessimistic'
                        },
                        unitSystem: google.maps.UnitSystem.IMPERIAL
                    }, function (response, status) {
                        if (status === 'OK') {
                            vm.directionsDisplay.setDirections(response)
                        }
                    })
                    clearInterval(interval);
                    interval = null
                }
            },1000);
        })
    }


    mapStyle = {
        disableDefaultUI : true,
        styles: [
        {
          "featureType": "landscape.natural",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": "-2"
              }
          ]
      },
      {
          "featureType": "landscape.natural.landcover",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.landcover",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.landcover",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.landcover",
          "elementType": "labels.text.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.terrain",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "landscape.natural.terrain",
          "elementType": "labels.text.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#d4d4d4"
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#3674ff"
              },
              {
                  "lightness": "27"
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "color": "#3674ff"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#3674ff"
              },
              {
                  "lightness": "51"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "color": "#3674ff"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#5995ea"
              },
              {
                  "saturation": "0"
              },
              {
                  "lightness": "50"
              }
          ]
      }
    ]}
}
